<template>
	<div class="box">
        <div class="field">
            <p class="title">Upload Tech Document</p>
        </div>

        <hr style="margin-left:25px;margin-right:25px;"/>

        <b-form-file
            class="upload-box text-nowrap text-truncate"
            size="lg"
            v-model="uploadFile"
            placeholder="Choose or Drop file here"
            drop-placeholder="Drop file here"
			@input="select()"
        ></b-form-file>
		<table>
			<tr>
                <td>
                    <b style="white-space:nowrap;">File Name</b>
                </td>
                <td style="width:90%">
                    <input style="width:100%" v-model="filename"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <b style="white-space:nowrap;">Notes</b>
                </td>
                <td>
                    <textarea style="width:100%; min-height:30px; height:60px; max-height:125px;" v-model="notes"></textarea>
                </td>
            </tr>
		</table>
		<br/>
		<img v-if="uploadFile!=null" id="file_upload" src="#" style="width:30%"></img>

		<hr style="margin-left:25px;margin-right:25px;"/>

		<div class="uploading-box" v-bind:class="{ hidden: !loading }">
			<div v-bind:id="'loading-progress'" class="uploading-bar-green"></div>
		</div>
		<button :disabled="!ready" v-on:click="upload()" v-bind:class="{ hidden: uploading}">Upload</button>
		<div class="uploading-box" v-bind:class="{ hidden: !uploading }">
			<div v-bind:id="'progress'" class="uploading-bar">
				<p v-bind:id="'progress-text'" class="upload-text"></p>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_TECHDOCS_PAGE,
			filename:'',
			notes:'',
			uploadFile:null,
			file:null,
			uploading:false,
			loading:false,
			ready:false,
			progressBar:null,
			loadingBar:null,
		}
	},
	methods:{
		async select(){
			this.file=null;
			this.loading=true;
			this.ready=false;
			this.loadingBar.style = "width:0%"

			if(this.uploadFile!=null){
				new Promise((resolve, reject) => {
					var reader = new FileReader()
					reader.onload = function(e){
						this.file = {imageName:this.uploadFile.name, imageData:e.target.result}
						resolve(null);
					}.bind(this);

					reader.onprogress = function(e){
						if (e.lengthComputable) {
			                var progress = parseInt( ((e.loaded / e.total) * 100), 10 );
							this.loadingBar.style = "width:"+progress+"%"
			            }
					}.bind(this);

					reader.onerror = function(e){
						console.log(e)
						this.uploading=false;
						this.loading=false;
						this.ready=false;
						this.uploadFile = null
						this.file = null
						document.getElementById("file_upload").src = "#"

						alert("error: File could not be read")
						reject(null);
					}.bind(this);

					reader.readAsDataURL(this.uploadFile)
		        }).then((res) => {
					this.loading=false;
					this.ready=true;
				})
			}
		},
		upload(){
			this.uploading=true;
			this.ready=false;
			this.progressBar.style = "width:0%"

			api.postDataImage(
				{
					data:{
						pageid:this.pageid,
						file:this.file,
						filename:this.filename,
						notes:this.notes,
						term:this.term,
					}
				},
				this.progressBar
			).then((res) => {

				this.uploadFile = null
				this.file = null
				this.filename = ''
				this.notes = ''
				document.getElementById("file_upload").src = "#"

				alert(res.data.message)
			}).finally((res) => {
				this.uploading=false;
				this.loading=false;
				this.ready=false;
			})
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.progressBar = document.getElementById("progress")
			this.loadingBar = document.getElementById("loading-progress")
			this.progressBar.style = "width:0%"
			this.loadingBar.style = "width:0%"
		})
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    text-align:center;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

.upload-box{
    width:75%;
}

.custom-file-input ~ .custom-file-label::after {
  content: 'sh';
}

table {
    table-layout:auto;
    margin:auto;
    width:50%;
    border: none;
}
td {
    border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/add/Add_Techdocs.vue